/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StateIcon/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Cancelled from './Cancelled/index'
import CheckedOut from './CheckedOut/index'
import No from './No/index'
import NoShow from './NoShow/index'
import React from 'react'
import Scheduled from './Scheduled/index'
import Unscheduled from './Unscheduled/index'
import Unseated from './Unseated/index'



/** @type {import('Simple/types.js').View} */
export default function StateIcon({
  children,
  viewPath = "/DesignSystem/AppointmentBookingStateTextWithIcon/StateIcon",
  fill2
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedStateValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'state',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedStateValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Scheduled'}>
<Scheduled
  viewPath={`${viewPath}/Scheduled`}
 fill2={fill2}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Cancelled'}>
<Cancelled
  viewPath={`${viewPath}/Cancelled`}
 fill2={fill2}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NoShow'}>
<NoShow
  viewPath={`${viewPath}/NoShow`}
 fill2={fill2}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Unseated'}>
<Unseated
  viewPath={`${viewPath}/Unseated`}
 fill2={fill2}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CheckedOut'}>
<CheckedOut
  viewPath={`${viewPath}/CheckedOut`}
 fill2={fill2}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Unscheduled'}>
<Unscheduled
  viewPath={`${viewPath}/Unscheduled`}
 fill2={fill2}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}